import React,{useState,useEffect,useRef} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import moment from 'moment'
import {BsSearch} from 'react-icons/bs'
import { empwiseattApi } from '../../../utils/AdminDashApi/EmpWiseAttApi'
import '../../../sassFiles/sassPages/admindashboard/campwiseatten.scss'
import '../../../sassFiles/sassPages/admindashboard/adminCommon.scss'
import { empAttreportApi } from '../../../utils/AdminDashApi/EmpAttReportApi'
import { BsPlus } from 'react-icons/bs'
import { optionsCampus, optionsClass, optionsShift, optionsdayofmonth, optionsdayofweek, optionsdept, optionsdesignation, optionsexptype, purplebutton40 } from '../../Helper'
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'
import { studentSubjectApi } from '../../../utils/AdminDashApi/StudentSubjectApi'
import { validateTransactionApi } from '../../../utils/AdminDashApi/ValidateTransactionApi'
import { credinfostuApi, sendstucredApi } from '../../../utils/AdminDashApi/SendStuCredApi'
const SendStudentCredentialsComp = () => {

    const [studentidmain,setstudentidmain] = useState("")
    const [borderstudentidmain,setborderstudentidmain] = useState("")
    const [labelstudentidmain,setlabelstudentidmain] = useState("")

    const [isAssignrolechk,setisAssignrolechk] = useState("")

    const handleisAssignrolechk = event => {
        if (event.target.checked) {
          console.log('✅ Checkbox is checked');
          
        } else {
            console.log('⛔️ Checkbox is NOT checked');
            
        }
        setisAssignrolechk(current => !current);
      };

    const continueButton=()=>{

    }
    const handletextarea=(e)=>{
        
    }

  return (
    <>
        <div className="d-flex flexvaluecomp htshiftsetup">
            <SidebarOfAdash />
            <div className="contentpartwidthwrapper">
                <HeaderofAdash head="Student Subject" />
                <div className="contentofadmindash contentflexvalue">
                    <Row className="sendstucredmain">
                        <Col lg={6} className='m-auto'>
                        
                          <Row>
                            <Col lg={9}>
                            <div className="basicinputfield h40p">
                            <p>Student ID</p>
                            <div className="inputgap h35">
                              <input style={borderstudentidmain ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={studentidmain} onChange={(e) => setstudentidmain(e.target.value)} placeholder='Enter Last 4 digits of Student Id' />
                              <label>{labelstudentidmain}</label>
                            </div>
                          </div>
                            </Col>
                            <Col lg={3}>
                                <div className="purplebutton" style={{marginTop:"18px"}}>
                                <button className='px-4 py-2' onClick={continueButton}>
                                        Get Info
                                </button>

                                </div>
                            </Col>
                          </Row>
                        </Col>
                    </Row>
                    <Row style={{marginTop:"85px"}} className="sendstudentcred">
                        <Col lg={10} className="m-auto" >
                            <Row>
                                <Col lg={6} className="pr7">

                            <div className="paragraphwrap">
                            <p>Student Information</p>
                           <div className="stuinfobox firstbox">
                           <table>
                                {
                                    sendstucredApi?sendstucredApi.data.map((item,key)=>{
                                        return(
                                            <tr key={key}>
                                   
                                                <td>
                                                    <span>{item.name}</span> <span>:</span>
                                                </td>
                                                <td>
                                                    {item.value}
                                                </td>
                                            </tr>
                                        )
                                    })
                                    :
                                    sendstucredApi.data.map((item,key)=>{
                                        return(
                                            <tr key={key}>
                                   
                                                <td>
                                                    <span>{item.name}</span> <span>:</span>
                                                </td>
                                            </tr>
                                        )
                                    })

                                }
                               
                               
                            </table>
                           </div>
                            </div>
                                </Col>
                                <Col lg={6} className="pl7">

                            <div className="paragraphwrap">
                            <p>Credential Information</p>
                           <div className="stuinfobox firstbox secondbox">
                           <table>
                                {
                                    credinfostuApi?credinfostuApi.data.map((item,key)=>{
                                        return(
                                            <tr key={key}>
                                   
                                                <td>
                                                    <span>{item.name}</span> <span>:</span>
                                                </td>
                                                <td>
                                                    {item.value}
                                                </td>
                                            </tr>
                                        )
                                    })
                                    :
                                    credinfostuApi.data.map((item,key)=>{
                                        return(
                                            <tr key={key}>
                                   
                                                <td>
                                                    <span>{item.name}</span> <span>:</span>
                                                </td>
                                            </tr>
                                        )
                                    })

                                }
                               
                               
                            </table>
                           </div>
                            </div>
                                </Col>
                                <Col lg={6} className="pr7">

                                <div className="paragraphwrap mt-3">
                                    <p>Role Information</p>
                                    <div className="stuinfobox firstbox thirdbox">
                                        <h4 className="text-center">Current Role State:</h4>
                                        <p>If the current role status is "Not Assigned", please assign the role. Without assigning a role, the user can't log in to his/her panel. Check the box to assign a role.</p>
                                        
                                            <div className="text-center">
                                            <div className="checkboxfull">                      
                                            <label className='checkcontainer'>
                                            Assign Role
                                            <input
                                                type="checkbox"
                                                value={isAssignrolechk}
                                                onChange={handleisAssignrolechk}
                                                id="remember"
                                                name="subscribe"                        
                                            />
                                            <span className="checkmark"></span>
                                            </label>
                                            
                                            </div>

                                            </div>
                                        
                                    </div>
                                </div>
                                </Col>
                                <Col lg={6} className="pl7">

                                <div className="paragraphwrap mt-3">
                                    <p>This credentials will send to the student via sms.</p>
                                    <div className="stuinfobox firstbox fourthbox">
                                           
                                           <textarea disabled id="fillupbox" type="text" value="hello" onChange={handletextarea} />
                                        
                                            <div className="text-center">
                                            <div className="checkboxfull">                      
                                            <label className='checkcontainer'>
                                            Send Credentials
                                            <input
                                                type="checkbox"
                                                value={isAssignrolechk}
                                                onChange={handleisAssignrolechk}
                                                id="remember"
                                                name="subscribe"                        
                                            />
                                            <span className="checkmark"></span>
                                            </label>
                                            
                                            </div>

                                            </div>
                                        
                                    </div>
                                </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <div className="buttonwrap text-center" style={{marginTop:"75px"}}>
                        <div className="purplebutton">
                            <button className="px-4 py-2">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default SendStudentCredentialsComp